import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Observable, take} from "rxjs";
import {selectIsDarkMode} from "../../state/ui/ui.selectors";
import {Store} from "@ngrx/store";
import * as UiActions from "../../state/ui/ui.actions";
import {AsyncPipe, NgClass, NgIf} from "@angular/common";

@Component({
  standalone: true,
  selector: 'app-dark-mode-toggle',
  templateUrl: './dark-mode-toggle.component.html',
  imports: [
    AsyncPipe,
    NgIf,
    NgClass
  ],
  styleUrls: ['./dark-mode-toggle.component.scss']
})
export class DarkModeToggleComponent {

  @Output() toggleChange = new EventEmitter<boolean>();
  isOn$: Observable<boolean>;

  @Input() mode: 'default' | 'dashboard' = 'default';

  constructor(private store: Store) {
    this.isOn$ = this.store.select(selectIsDarkMode);
  }

  ngOnInit() {
    //
  }

  toggle() {
    this.isOn$.pipe(take(1)).subscribe(currentMode => {
      const newMode = !currentMode;
      this.store.dispatch(UiActions.toggleDarkMode({ isDarkMode: newMode }));
      this.toggleChange.emit(newMode);
    });
  }

  /*
  toggle() {
    this.isOn = !this.isOn;
    this.toggleChange.emit(this.isOn);
  }
 */

}
